import i18next from 'i18next';
import { accessRoute } from '../../routes/Dashboard';
import {
  getInputSearchFilter,
  getPriceFilter,
  getMultiSelectSearchFilter,
} from '../../components';
import {
  checkValidData,
  checkValidDiscountType,
  checkValidPrice,
} from '../../components/UIElements/Formatter';
import { accessRoute as membershipRoute } from '../../routes/Membership';
import { getTupleStatusList } from '../index.service';
import { readMoreTextShow } from '../../utils';

export const memberShipBreadcrumb = () => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: '#',
      name: i18next.t('text.memberShip.heading'),
    },
  ];
};
export const addMembershipPlanBreadcrumb = ({ text }) => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: membershipRoute.MEMBERSHIP.path,
      name: i18next.t('text.memberShip.heading'),
    },
    {
      path: '#',
      name:
        text === 'add'
          ? i18next.t('text.memberShip.addMembershipPlan')
          : i18next.t('text.memberShip.editMembershipPlan'),
    },
  ];
};
// use temporary keys
const priceCostFields = {
  fromOperatorField: 'firstOperator',
  fromOperatorAmountField: 'firstAmount',
  conditionalField: 'conditional',
  toOperatorField: 'secondOperator',
  toOperatorAmountField: 'secondAmount',
};
export const memberShipColumn = ({ Action, Toggle }) => {
  return [
    {
      dataIndex: 'id',
      title: i18next.t('text.common.serialNo'),
      headerClasses: 'w_70',
      // render: (cell, row, index) =>
      //   serialNumberFormatter({ page, sizePerPage, index }),
      // exportFormatter: (cell, row, index) =>
      //   serialNumberFormatter({ page, sizePerPage, index }),
    },
    {
      dataIndex: 'title',
      title: i18next.t('text.common.title'),
      filterDataIndex: ['search'],
      sorter: true,
      render: (cell, row) => checkValidData(cell),
      ...getInputSearchFilter({
        dataIndex: 'search',
        placeholder: i18next.t('text.common.titlePlaceholder'),
      }),
    },
    {
      dataIndex: 'monthlyCost',
      title: i18next.t('text.memberShip.monthlyCost'),
      headerClasses: 'sorting',
      sorter: true,
      render: (cell, row) => checkValidDiscountType(row?.discountType, cell),
      ...getPriceFilter({
        dataIndex: 'price',
        // onFilterChange,
        fields: priceCostFields,
        // filter,
      }),
      // ...getColumnSelectAmountProps('monthly cost'),
    },
    {
      dataIndex: 'yearlyOneTimeCost',
      title: i18next.t('text.memberShip.yearlyOneTime'),
      headerClasses: 'sorting',
      sorter: true,
      render: (cell, row) => checkValidPrice(cell),
      ...getPriceFilter({
        dataIndex: 'price',
        // onFilterChange,
        fields: priceCostFields,
        // filter,
      }),
      // ...getColumnSelectAmountProps('yearly one time cost'),
    },
    {
      dataIndex: 'additionalDiscount',
      title: i18next.t('text.memberShip.additionalDiscount'),
      headerClasses: 'sorting',
      sorter: true,
      render: (cell, row) => checkValidData(cell),
      ...getInputSearchFilter({
        dataIndex: 'search',
        placeholder: i18next.t('text.memberShip.discountPlaceholder'),
      }),
      // ...getColumnSearchProps('additional discount'),
    },
    // {
    //   dataIndex: 'lengthOfMembership',
    //   title: i18next.t('text.memberShip.lengthOfMembership'),
    //   headerClasses: 'sorting',
    //   sorter: true,
    //   render: (cell, row) => checkValidData(cell),
    //   ...getInputSearchFilter({
    //     dataIndex: 'search',
    //     placeholder: i18next.t('text.memberShip.lengthOfMembershipPlaceholder'),
    //   }),
    //   // ...getColumnSearchProps('length of membership'),
    // },
    {
      dataIndex: 'displayOrder',
      title: i18next.t('text.memberShip.displayOrder'),
      headerClasses: 'sorting',
      sorter: true,
      render: (cell, row) => checkValidData(cell),
      ...getInputSearchFilter({
        dataIndex: 'search',
        placeholder: i18next.t('text.memberShip.displayOrderPlaceholder'),
      }),
    },
    {
      dataIndex: 'description',
      title: i18next.t('text.common.description'),
      headerClasses: 'sorting',
      sorter: true,
      render: (cell, row) =>
        readMoreTextShow(
          checkValidData(cell),
          i18next.t('text.common.description'),
          20
        ),
      ...getInputSearchFilter({
        dataIndex: 'search',
        placeholder: i18next.t('text.common.descriptionPlaceholder'),
      }),
    },
    {
      dataIndex: 'status',
      title: i18next.t('text.common.status'),
      headerClasses: 'sorting',
      render: (cell, row) => {
        return <Toggle row={row} cell={cell} />;
      },
      ...getMultiSelectSearchFilter({
        dataIndex: 'status',
        // onFilterChange,
        // filter,
        name: 'status',
        list: [],
        mode: false,
        listService: getTupleStatusList,
      }),
      sorter: true,
      // ...getColumnSelectSearchProps('status', getActionData()),
    },
    {
      dataIndex: 'action',
      title: i18next.t('text.common.action'),
      className: 'nk-tb-col-tools text-end',
      render: (cell, row) => <Action row={row} cell={cell} />,
    },
  ];
};

export const membershipService = () => {
  return [
    {
      id: 1,
      title: 'Plan 1',
      monthlyCost: '14.50',
      discountType: 'percentage',
      yearlyOneTimeCost: '150',
      additionalDiscount: '10%',
      lengthOfMembership: '1 Year',
      displayOrder: '1',
      description: 'Furnace cleaning plan',
      status: 'Active',
    },
    {
      id: 2,
      title: 'Plan 2',
      monthlyCost: '20',
      discountType: 'amount',
      yearlyOneTimeCost: '200',
      additionalDiscount: '15%',
      lengthOfMembership: '2 Year',
      displayOrder: '10',
      description: 'Premium Plan',
      status: 'Inactive',
    },
  ];
};
